import React, { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

export const StatsCounter = ({ value, label }) => {
  const reduced = useReducedMotion();
  const ref = useRef();
  const [display, setDisplay] = useState(reduced ? value : value);

  // parse numeric portion
  const match = String(value).match(/([\d.,]+)/);
  const numeric = match ? parseFloat(match[1].replace(/\./g, '').replace(',', '.')) : null;
  const suffix = match ? value.replace(match[1], '') : '';
  const prefix = match && value.indexOf(match[1]) > 0 ? value.slice(0, value.indexOf(match[1])) : '';

  const [started, setStarted] = useState(false);
  useEffect(() => {
    if (reduced || numeric === null) { setDisplay(value); return; }
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !started) {
        setStarted(true);
        const duration = 1400;
        const start = performance.now();
        const isFloat = match[1].includes(',') || match[1].includes('.');
        const step = (now) => {
          const p = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          const current = numeric * eased;
          setDisplay(prefix + (isFloat ? current.toFixed(2) : Math.round(current).toString()) + suffix);
          if (p < 1) requestAnimationFrame(step);
          else setDisplay(value);
        };
        requestAnimationFrame(step);
      }
    }, { threshold: 0.4 });
    obs.observe(node);
    return () => obs.disconnect();
  }, [numeric, started, value, reduced]);

  return (
    <div ref={ref} className="text-center" data-testid="stat-item">
      <div className="font-mono text-3xl sm:text-4xl font-semibold text-[color:var(--itw-cyan)] text-glow">{display}</div>
      <div className="mt-2 text-sm text-[color:var(--itw-text-2)]">{label}</div>
    </div>
  );
};
